import type { DomainManifest } from 'modules/core/lib/manifests/types'

import { DefaultComplianceSettingsCreateActivity } from 'modules/finance/activities/defaultComplianceSettings/defaultComplianceSettingsCreate'
import { DefaultComplianceSettingsDeleteActivity } from 'modules/finance/activities/defaultComplianceSettings/defaultComplianceSettingsDelete'
import { DefaultComplianceSettingsUpdateActivity } from 'modules/finance/activities/defaultComplianceSettings/defaultComplianceSettingsUpdate'
import { FinanceContactCreateActivity } from 'modules/finance/activities/financeContactCreate'
import { SalesDocumentTemplateCreateActivity } from 'modules/finance/activities/salesDocumentTemplate/salesDocumentTemplateCreate'
import { SalesDocumentTemplateDeleteActivity } from 'modules/finance/activities/salesDocumentTemplate/salesDocumentTemplateDelete'
import { SalesDocumentTemplateUpdateActivity } from 'modules/finance/activities/salesDocumentTemplate/salesDocumentTemplateUpdate'
import { SerialSequenceCreateActivity } from 'modules/finance/activities/serialSequenceCreate'
import { SerialSequenceDeleteActivity } from 'modules/finance/activities/serialSequenceDelete'
import { SerialSequenceUpdateNameActivity } from 'modules/finance/activities/serialSequenceUpdateName'

import { sidebarManifest } from './sidebar'

export const manifest = {
  sidebar: (navigation) => ({
    items: sidebarManifest(navigation),
  }),
  activities: {
    salesDocumentTemplateCreate: {
      component: SalesDocumentTemplateCreateActivity,
    },
    salesDocumentTemplateDelete: {
      component: SalesDocumentTemplateDeleteActivity,
    },
    salesDocumentTemplateUpdate: {
      component: SalesDocumentTemplateUpdateActivity,
    },
    serialSequenceCreate: {
      component: SerialSequenceCreateActivity,
    },
    serialSequenceUpdateName: {
      component: SerialSequenceUpdateNameActivity,
    },
    serialSequenceDelete: {
      component: SerialSequenceDeleteActivity,
    },
    contactCreate: {
      component: FinanceContactCreateActivity,
    },
    defaultComplianceSettingsCreate: {
      component: DefaultComplianceSettingsCreateActivity,
    },
    defaultComplianceSettingsUpdate: {
      component: DefaultComplianceSettingsUpdateActivity,
    },
    defaultComplianceSettingsDelete: {
      component: DefaultComplianceSettingsDeleteActivity,
    },
  },
} as const satisfies DomainManifest
